const getAppVersion = (str: string): string | null => {
  const ua = str || navigator.userAgent;
  const reg = /duitang\/([^\s]+)/i;
  const matchArr = ua.match(reg);
  if (matchArr) {
    return matchArr[1];
  }
  return null;
};

export default getAppVersion;
